import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, HostListener } from '@angular/core';
import { SatPopover } from '@ncstate/sat-popover';
import { Subscription, interval, takeWhile } from 'rxjs';
import { ContextualHelpModel } from 'src/app/models/contextualHelp';
import { ImportFormat } from 'src/app/models/importFormat';
import { ContextualHelpService } from 'src/app/services/contextualHelpService';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { SearchService } from 'src/app/services/search.service';

@Component({
  selector: 'app-menu-option',
  templateUrl: './menu-option.component.html',
  styleUrls: ['./menu-option.component.scss'],
  standalone: false
})
export class MenuOptionComponent implements OnInit, OnDestroy {

  @Input() label: string;
  @Input() labelOnMenu: string;
  @Input() action: Function = null;
  @Input() fileExplorer: boolean = false;
  @Input() fileFormats: ImportFormat = ImportFormat.ALL_FORMATS;
  @Input() operationAllowedValidator: () => Promise<boolean> = null;

  @ViewChild(SatPopover) tooltipModal: SatPopover;
  @ViewChild('fileElement', { static: true }) fileInput: ElementRef<HTMLInputElement>;

  available: boolean = false
  contextualHelpModel: ContextualHelpModel;

  isTooltipOpen: boolean = false;

  constructor(public contextualHelpService: ContextualHelpService,
    public searchService: SearchService,
    public modalMessage: ModalControlService,
    public http: HttpClient,
    public endpointService: EndpointsService,
    private elementRef: ElementRef
  ) {

  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.tooltipModal.isOpen()) {
      this.tooltipModal.close();
    }
  }
  async callAction() {
    if (this.action != null) {
      if (this.operationAllowedValidator != null && !(await this.operationAllowedValidator())) {
        return;
      }
      if (this.contextualHelpService.isMenuOptionEnabled(this.label)) {
        if (this.fileExplorer) {
          this.fileInput.nativeElement.click();
        }
        else {
          this.action();
        }
      }
      else {
        this.modalMessage.showMesssageModal("Warning!", ContextualHelpService.UNAVAILABLE_OPTION);
      }
    }

  }
  fileExplorerCallBack(file: any) {
    this.action(file);
  }

  isTooltipOpened() {
    return this.isTooltipOpen;
  }

  toggleTooltip() {
    this.isTooltipOpen = !this.isTooltipOpen;
  }

  isTooltipAvailable() {
    this.contextualHelpModel = this.contextualHelpService.contextualHelpToolTips
      .find((contextualHelp: ContextualHelpModel) => contextualHelp.functionality.toLowerCase() == this.label.toLowerCase())
    if (this.contextualHelpModel && this.contextualHelpModel.isEnabled
      && ((this.contextualHelpModel.linkName != "" && this.contextualHelpModel.linkName != null)
        || (this.contextualHelpModel.descriptionText != "" && this.contextualHelpModel.descriptionText != null)
        || (this.contextualHelpModel.link != "" && this.contextualHelpModel.link != null)
      )
    ) {
      return true;
    } else {
      return false;
    }
  }

  public openclose(event: MouseEvent) {
    // Prevent the click event from propagating further
    event.stopPropagation();

    if (this.tooltipModal.isOpen()) {
      this.tooltipModal.close();
    } else {
      if (this.isTooltipAvailable()) {
        this.tooltipModal.open();
      }
    }
  }

  ngOnInit(): void {
    this.searchService.createNewSearchItem(this.label, this.action, this.fileExplorer);
    let createIfItDoesNotExist = true;
    const checkAuthSubscription: Subscription = interval(100) // ms
      .pipe(takeWhile(() => !this.endpointService.httpOptions, true))
      .subscribe(async () => {
        if (this.endpointService.httpOptions) {
          checkAuthSubscription.unsubscribe();
          this.contextualHelpModel = await this.contextualHelpService.ensureExists(this.label);

        }
      });
  }
  ngOnDestroy() {
    this.searchService.deleteSearchItem(this.label);
  }
}
